var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout"},[_c('BaseLoader',{staticClass:"logout__logo"}),_c('div',{staticClass:"logout__inner"},[_vm._v(" "+_vm._s(_vm.$trans('auth.logout.title', _vm.TranslationModule.COMMON))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }